import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Check } from 'lucide-react';
import { services, engagementGears, images } from '../mock';

const Services = () => {
  return (
    <main className="pt-32">
      <section className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-8">
            <div className="text-[11px] tracking-[0.24em] uppercase text-[#6B8E4E]">What we do</div>
            <h1 className="font-serif-display text-6xl md:text-8xl text-[#1E3A2B] mt-6 leading-[0.98] tracking-[-0.02em]">
              Coaching, consulting <span className="italic text-[#6B8E4E]">& conversations</span>.
            </h1>
          </div>
        </div>
      </section>

      {/* Service blocks */}
      <section className="mt-20">
        {services.map((s, idx) => (
          <div key={s.id} id={s.id} className={`py-20 scroll-mt-24 ${idx % 2 === 1 ? 'bg-[#F3EFDF]' : ''}`}>
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-10 items-center">
              <div className={`md:col-span-6 ${idx % 2 === 1 ? 'md:order-2' : ''}`}>
                <div className="relative rounded-[28px] overflow-hidden aspect-[5/4]">
                  {idx === 0 ? (
                    <div
                      className="absolute top-1/2 left-1/2 w-[80%] aspect-[4/5]"
                      style={{ transform: 'translate(-50%, -50%) rotate(-90deg)' }}
                    >
                      <img
                        src={images.coaching}
                        alt={s.title}
                        className="w-full h-full object-cover image-zoom"
                      />
                    </div>
                  ) : (
                    <img
                      src={idx === 1 ? images.workshop : images.speaking}
                      alt={s.title}
                      className={`w-full h-full object-cover image-zoom ${idx === 2 ? 'object-left' : ''}`}
                    />
                  )}
                </div>
              </div>
              <div className={`md:col-span-6 ${idx % 2 === 1 ? 'md:order-1' : ''}`}>
                <div className="text-[11px] tracking-[0.24em] uppercase text-[#6B8E4E]">{s.kicker}</div>
                <h2 className="font-serif-display text-5xl md:text-6xl text-[#1E3A2B] mt-4 leading-[1.02]">{s.title}</h2>
                <div className="mt-2 text-[14px] tracking-[0.14em] uppercase text-[#E27B47]">{s.subtitle}</div>
                <p className="mt-6 text-[16px] text-[#3d4a41] leading-relaxed max-w-xl">{s.body}</p>
                {s.bulletsIntro && (
                  <p className="mt-6 text-[14px] tracking-wide text-[#1E3A2B] font-medium">{s.bulletsIntro}</p>
                )}
                <ul className="mt-8 space-y-3">
                  {s.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-3 text-[15px] text-[#1E3A2B]">
                      <span className="mt-1 w-5 h-5 rounded-full bg-[#1E3A2B] text-[#B8CE7F] flex items-center justify-center shrink-0">
                        <Check className="w-3 h-3" />
                      </span>
                      {b}
                    </li>
                  ))}
                </ul>
                <Link to="/contact"
                  className="mt-10 btn-transition inline-flex items-center gap-2 bg-[#1E3A2B] hover:bg-[#152B20] text-[#FAF6EE] px-6 py-3 rounded-full text-[14px]">
                  Enquire about {s.title.split(' ')[0]} <ArrowUpRight className="w-4 h-4" />
                </Link>
              </div>
            </div>
          </div>
        ))}
      </section>

      {/* CTA */}
      <section className="py-24 md:py-32 bg-[#F3EFDF]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <div className="grid md:grid-cols-12 gap-10 items-center">
            <div className="md:col-span-8">
              <div className="text-[11px] tracking-[0.24em] uppercase text-[#6B8E4E]">Next step</div>
              <h2 className="font-serif-display text-5xl md:text-7xl text-[#1E3A2B] mt-4 leading-[1.02]">
                Curious where to<br /> begin? Start with a chat.
              </h2>
            </div>
            <div className="md:col-span-4 md:text-right">
              <Link to="/contact"
                className="btn-transition inline-flex items-center gap-2 bg-[#E27B47] hover:bg-[#D06A38] text-[#FAF6EE] px-7 py-4 rounded-full text-[14px]">
                Book a discovery call <ArrowUpRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Services;
